// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "one.mixin.messenger",
    name: "Mixin Messenger",
    homepage: "https://messenger.mixin.one",
    image_id: "c5516ab5-57c3-45ec-09e2-b149c9709600",
    app: {
        browser: "https://mixin.one",
        ios: "https://apps.apple.com/app/mixin/id1322324266",
        android: "https://play.google.com/store/apps/details?id=one.mixin.messenger",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "one.mixin.messenger",
    mobile: {
        native: "mixin://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map